import { render } from "./VerifyPhonePage.vue?vue&type=template&id=80541a0e&scoped=true"
import script from "./VerifyPhonePage.vue?vue&type=script&lang=js"
export * from "./VerifyPhonePage.vue?vue&type=script&lang=js"

import "./VerifyPhonePage.vue?vue&type=style&index=0&id=80541a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80541a0e"]])

export default __exports__